(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  var OPEN_DELAY = 180;
  var CLOSE_DELAY = 300; 
  var SUB_DELAY = 120;
  // var SUB_SWITCH_DELAY = 320; 
  var SUB_SWITCH_DELAY = 100;

  function pointInTriangle(p, a, b, c) {
    var v0x = c.x - a.x;
    var v0y = c.y - a.y;
    var v1x = b.x - a.x;
    var v1y = b.y - a.y;
    var v2x = p.x - a.x;
    var v2y = p.y - a.y;
    var dot00 = v0x * v0x + v0y * v0y;
    var dot01 = v0x * v1x + v0y * v1y;
    var dot02 = v0x * v2x + v0y * v2y;
    var dot11 = v1x * v1x + v1y * v1y;
    var dot12 = v1x * v2x + v1y * v2y;
    var denom = dot00 * dot11 - dot01 * dot01;
    if (!denom) return false;
    var inv = 1 / denom;
    var u = (dot11 * dot02 - dot01 * dot12) * inv;
    var v = (dot00 * dot12 - dot01 * dot02) * inv;
    return u >= 0 && v >= 0 && (u + v) <= 1;
  }

  DNB.Nav = {
    init: function () {
      var header = document.querySelector("[data-site-header]");
      if (!header || header.getAttribute("data-nav-init") === "1") return;
      header.setAttribute("data-nav-init", "1");

      this.header = header;
      this.overlay = document.querySelector("[data-nav-overlay]");
      this.desktopMQ = window.matchMedia("(min-width: 1025px)");

      this.bindScrollState(header);
      this.bindSearch(header);
      this.bindLanguage(header);
      this.bindMenu(header);
      this.bindMobile(header);
    },

    isDesktop: function () {
      return this.desktopMQ.matches;
    },

    bindScrollState: function (header) {
      function update() {
        header.classList.toggle("is-scrolled", window.scrollY > 40);
      }
      update();
      window.addEventListener("scroll", update, { passive: true });
    },

    bindSearch: function (header) {
      var toggle = header.querySelector("[data-search-toggle]");
      var panel = header.querySelector("[data-search]");
      var input = header.querySelector("[data-search-input]");
      var closeBtn = header.querySelector("[data-search-close]");
      if (!toggle || !panel) return;

      function focusInput() {
        if (!input) return;
        input.focus({ preventScroll: true });
        var end = input.value.length;
        try {
          input.setSelectionRange(end, end);
        } catch (err) {}
      }

      function setState(open) {
        panel.classList.toggle("is-open", open);
        header.classList.toggle("search-is-open", open);
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        var icon = toggle.querySelector(".icon");
        if (icon) {
          icon.classList.toggle("icon--search-light", !open);
          icon.classList.toggle("icon--close-light", open);
        }
        if (open) {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(focusInput);
          });
        }
      }

      toggle.addEventListener("click", function () {
        setState(!panel.classList.contains("is-open"));
      });
      if (closeBtn) closeBtn.addEventListener("click", function () {
        if (input) input.value = "";
        setState(false);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && panel.classList.contains("is-open")) setState(false);
      });
    },

    bindLanguage: function (header) {
      var wrap = header.querySelector("[data-lang]");
      var toggle = header.querySelector("[data-lang-toggle]");
      if (!wrap || !toggle) return;

      toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        wrap.classList.toggle("is-open");
      });
      document.addEventListener("click", function () {
        wrap.classList.remove("is-open");
      });

      wrap.querySelectorAll(".header-lang__link").forEach(function (link) {
        link.addEventListener("click", function () {
          wrap.querySelectorAll(".header-lang__link").forEach(function (l) { l.classList.remove("is-active"); });
          link.classList.add("is-active");
          wrap.classList.remove("is-open");
        });
      });
    },

    bindMenu: function (header) {
      var self = this;
      var menus = Array.prototype.slice.call(header.querySelectorAll("[data-nav-menu]"));
      if (!menus.length) return;

      var items = [];
      menus.forEach(function (menu) {
        items = items.concat(Array.prototype.slice.call(menu.querySelectorAll("[data-nav-item]")));
      });
      var openTimer = null;
      var closeTimer = null;

      function clearTimers() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      }

      function resetSubs(item) {
        item.querySelectorAll("[data-nav-subitem].is-active").forEach(function (s) {
          s.classList.remove("is-active");
        });
      }
      // Mega panel'de 1. alt kırılım (col), 2. alt kırılım (leaf) ve features
      // alanları absolute konumlandığı için en yükseğe göre eşitlenir; taşmayı önler.
      // leaf/feature aktif olunca bu genişliklere ulaşır (bkz. _header.scss .is-active).
      var LEAF_WIDTH = 300;
      var FEATURE_WIDTH = 460;

      // display:none olan elemanı, aktif genişliğinde geçici görünür kılıp
      // gerçek içerik yüksekliğini (padding + border dahil) ölçer.
      function measureAt(el, width) {
        var s = el.style;
        var save = {
          display: s.display, width: s.width, minWidth: s.minWidth,
          height: s.height, minHeight: s.minHeight, visibility: s.visibility
        };
        s.visibility = "hidden";
        s.display = "flex";
        s.width = width + "px";
        s.minWidth = width + "px";
        s.height = "auto";
        s.minHeight = "0";
        var h = el.offsetHeight;
        s.display = save.display;
        s.width = save.width;
        s.minWidth = save.minWidth;
        s.height = save.height;
        s.minHeight = save.minHeight;
        s.visibility = save.visibility;
        return h;
      }

      function clearEqualize(item) {
        var col = item.querySelector(".nav-menu__col");
        if (col) col.style.minHeight = "";
        item.querySelectorAll(".nav-menu__leaf, .nav-menu__feature").forEach(function (el) {
          el.style.minHeight = "";
        });
      }

      function equalizeMega(item) {
        clearEqualize(item);
        if (!self.isDesktop()) return;

        var leaves = item.querySelectorAll(".nav-menu__leaf");
        var features = item.querySelectorAll(".nav-menu__feature");
        if (!leaves.length && !features.length) return; // basit menü: eşitleme gerekmez

        var col = item.querySelector(".nav-menu__col");
        // 1. alt kırılım (col) gerçek yüksekliği — zaten görünür/akışta
        var maxH = col ? col.offsetHeight : 0;

        leaves.forEach(function (l) {
          var h = measureAt(l, LEAF_WIDTH);
          if (h > maxH) maxH = h;
        });
        features.forEach(function (f) {
          var h = measureAt(f, FEATURE_WIDTH);
          if (h > maxH) maxH = h;
        });

        // En yüksek olanı üç alana da min-height olarak bas → eşit yükseklik, taşma yok
        if (col) col.style.minHeight = maxH + "px";
        leaves.forEach(function (l) { l.style.minHeight = maxH + "px"; });
        features.forEach(function (f) { f.style.minHeight = maxH + "px"; });
      }
      this.equalizeOpen = function () {
        var open = header.querySelector(".nav-menu__item.is-open");
        if (open) equalizeMega(open);
      };

      function closeAll() {
        items.forEach(function (it) {
          it.classList.remove("is-open");
          resetSubs(it);
          clearEqualize(it);
        });
        if (self.overlay) self.overlay.classList.remove("is-open");
      }
      this.closeMenu = closeAll;

      function openItem(item) {
        items.forEach(function (it) {
          if (it !== item) { it.classList.remove("is-open"); resetSubs(it); }
        });
        item.classList.add("is-open");
        if (self.overlay) self.overlay.classList.add("is-open");
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(function () { equalizeMega(item); });
        } else {
          equalizeMega(item);
        }
      }

      items.forEach(function (item) {
        var hasMega = item.classList.contains("has-mega");
        var link = item.querySelector(".nav-menu__link");

        // Desktop hover with intent delay
        item.addEventListener("mouseenter", function () {
          if (!self.isDesktop() || !hasMega) return;
          clearTimers();
          openTimer = setTimeout(function () { openItem(item); }, OPEN_DELAY);
        });
        item.addEventListener("mouseleave", function () {
          if (!self.isDesktop() || !hasMega) return;
          clearTimers();
          closeTimer = setTimeout(closeAll, CLOSE_DELAY);
        });

        // Click (works for mobile + touch + desktop toggle)
        if (link) {
          link.addEventListener("click", function (e) {
            if (!hasMega) return; // plain link → let it be
            e.preventDefault();
            clearTimers();
            if (item.classList.contains("is-open")) {
              item.classList.remove("is-open");
              resetSubs(item);
              if (self.overlay && self.isDesktop()) self.overlay.classList.remove("is-open");
            } else {
              openItem(item);
            }
          });
        }

        // Sub-item interactions (level 2 -> level 3)
        var subItems = Array.prototype.slice.call(item.querySelectorAll("[data-nav-subitem]"));
        var subSwitchTimer = null;
        var activeSubItem = null;
        var lastPointer = { x: 0, y: 0 };
        var mega = item.querySelector(".nav-menu__mega");

        function clearSubSwitchTimer() {
          clearTimeout(subSwitchTimer);
          subSwitchTimer = null;
        }

        function syncActiveSubItem() {
          activeSubItem = item.querySelector("[data-nav-subitem].is-active.has-children") || null;
        }

        function activateSub(sub) {
          subItems.forEach(function (s) {
            if (s !== sub) s.classList.remove("is-active");
          });
          if (sub.classList.contains("has-children")) {
            sub.classList.add("is-active");
            activeSubItem = sub;
          } else {
            activeSubItem = null;
          }
          equalizeMega(item);
        }

        function getOpenPanelRect() {
          if (!activeSubItem) return null;
          var feature = activeSubItem.querySelector(".nav-menu__feature");
          var leaf = activeSubItem.querySelector(".nav-menu__leaf");
          var panel = null;
          if (feature && activeSubItem.classList.contains("has-feature")) panel = feature;
          else if (leaf) panel = leaf;
          if (!panel || panel.offsetParent === null) return null;
          return panel.getBoundingClientRect();
        }

        // Çapraz hareket: açık alt panelin sol kenarına doğru gidiliyorsa ara öğeleri tetikleme.
        function isInAimCorridor(x, y) {
          var rect = getOpenPanelRect();
          if (!rect) return false;
          var apex = lastPointer;
          var curr = { x: x, y: y };
          var pad = 24;
          var topLeft = { x: rect.left - pad, y: rect.top - pad };
          var bottomLeft = { x: rect.left - pad, y: rect.bottom + pad };
          return pointInTriangle(curr, apex, topLeft, bottomLeft);
        }

        function handleSubPointer(sub, x, y) {
          if (!self.isDesktop()) return;
          syncActiveSubItem();

          if (activeSubItem && activeSubItem !== sub) {
            if (isInAimCorridor(x, y)) {
              clearSubSwitchTimer();
              return;
            }
            scheduleSubSwitch(sub, SUB_SWITCH_DELAY);
            return;
          }

          if (sub.classList.contains("has-children")) {
            clearSubSwitchTimer();
            activateSub(sub);
            return;
          }

          scheduleSubSwitch(sub, SUB_DELAY);
        }

        function scheduleSubSwitch(sub, delay) {
          clearSubSwitchTimer();
          subSwitchTimer = setTimeout(function () {
            subSwitchTimer = null;
            activateSub(sub);
          }, delay);
        }

        if (mega) {
          mega.addEventListener("mousemove", function (e) {
            lastPointer = { x: e.clientX, y: e.clientY };
          });
        }

        subItems.forEach(function (sub) {
          var hasChildren = sub.classList.contains("has-children");
          var subLink = sub.querySelector(".nav-menu__sub-link");

          sub.addEventListener("mouseenter", function (e) {
            handleSubPointer(sub, e.clientX, e.clientY);
          });

          sub.addEventListener("mousemove", function (e) {
            if (activeSubItem && activeSubItem !== sub) {
              handleSubPointer(sub, e.clientX, e.clientY);
            }
          });

          sub.addEventListener("mouseleave", function () {
            clearSubSwitchTimer();
          });

          if (subLink) {
            subLink.addEventListener("click", function (e) {
              if (!hasChildren) return; // leaf link → navigate
              e.preventDefault();
              var active = sub.classList.contains("is-active");
              subItems.forEach(function (s) { s.classList.remove("is-active"); });
              if (!active) sub.classList.add("is-active");
              syncActiveSubItem();
            });
          }
        });

        item.querySelectorAll(".nav-menu__leaf, .nav-menu__feature").forEach(function (panel) {
          panel.addEventListener("mouseenter", function () {
            clearSubSwitchTimer();
            var parent = panel.closest("[data-nav-subitem]");
            if (!parent) return;
            subItems.forEach(function (s) {
              if (s !== parent) s.classList.remove("is-active");
            });
            parent.classList.add("is-active");
            activeSubItem = parent;
          });
        });
      });

      if (this.overlay) {
        this.overlay.addEventListener("click", closeAll);
      }
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeAll();
      });

      var resizeTimer = null;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (self.equalizeOpen) self.equalizeOpen();
        }, 150);
      });
    },

    bindMobile: function (header) {
      var self = this;
      var openBtn = header.querySelector("[data-mobile-open]");
      var closeBtns = header.querySelectorAll("[data-mobile-close]");
      var nav = header.querySelector(".site-header__nav");

      // Lenis sayfayı kilitlediğinde wheel olaylarını tümüyle yutar; menü paneli
      // bu yüzden kaydırılamaz. data-lenis-prevent ile panel içi native scroll açılır.
      if (nav) nav.setAttribute("data-lenis-prevent", "");

      function openNav() {
        header.classList.add("is-mobile-open");
        document.documentElement.classList.add("is-nav-open");
        document.body.classList.add("is-nav-open");
        if (nav) nav.scrollTop = 0;
        if (DNB.ScrollService) DNB.ScrollService.lock();
      }
      function closeNav() {
        header.classList.remove("is-mobile-open");
        document.documentElement.classList.remove("is-nav-open");
        document.body.classList.remove("is-nav-open");
        if (self.closeMenu) self.closeMenu();
        if (DNB.ScrollService) DNB.ScrollService.unlock();
      }

      if (openBtn) openBtn.addEventListener("click", openNav);
      closeBtns.forEach(function (btn) { btn.addEventListener("click", closeNav); });

      // Close mobile nav when switching to desktop
      this.desktopMQ.addEventListener("change", function (e) {
        if (e.matches) closeNav();
      });
    }
  };
})(window, document);
